export const classNames = (classObject) => {
  const classes = []

  Object.keys(classObject).map(key => {
    if (classObject[key]) classes.push(key)
  })

  return classes.join(' ')
}